<template>
  <v-container fluid>
    <v-card>
      <v-toolbar dense style="background:#F5F5F5">
        <v-toolbar-title dense style="color:#607D8B;font-weight:bold">Liste des sessions</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="refresh" icon>
          <v-icon color="#009688" large>mdi-refresh</v-icon>
          <template v-slot:loader>
            <span class="custom-loader"> <v-icon light>cached</v-icon></span>
          </template>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-dialog fullscreen v-model="loading">
          <v-container fill-height fluid style="background-color: rgba(200, 200, 200, 0.5);">
            <v-layout align-center="true" justify-center="true">
              <v-progress-circular
                  :on-cancel="onCancel"
                  :size="70"
                  color="#009688"
                  indeterminate>
              </v-progress-circular>
            </v-layout>
          </v-container>
        </v-dialog>
        <v-alert :color="AlertColor(type)"
                 :dismissible="true"
                 :value="true"
                 @input="dismissible_close"
                 border="top"
                 class="pre-formatted multi-line"
                 colored-border
                 elevation="2"
                 icon="check_circle"
                 style="color: #546E7A"
                 v-if="type">
          {{ text }}
        </v-alert>
        <v-card class="mt-1" flat
                tile>
          <v-row>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col>
              <v-text-field :disabled="disableMainBtn"
                            :id="dynamicID()"
                            @change="search"
                            @keyup.native.enter="search"
                            @click:clear="cleared()"
                            append-icon="mdi-magnify"
                            class="centered-input align-center"
                            clearable
                            hide-details
                            placeholder="Recherche"
                            v-model="searchName">
              </v-text-field>
            </v-col>
            <v-col>
              <v-btn :disabled="disableMainBtn" @click="onexport" block class="custom-btn white--text"
                     color="#00BCD4"
                     height="45px" large>
                <v-icon class="mr-1">mdi-file-excel-outline</v-icon>
                <span>Export sessions</span>
              </v-btn>
            </v-col>
            <v-col>
              <v-btn :disabled="disableMainBtn || selectedRows.length === 0 || dataIsEmpty" @click="removeSelectedRows" block
                     class="custom-btn white--text"
                     color="#F44336"
                     height="45px" large>
                <v-icon class="mr-1">mdi-delete</v-icon>
                <span>Supprimer sélection</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="mt-4"
                elevation="6">
          <hot-table :settings="hotSettings" ref="hotTable"></hot-table>
        </v-card>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import {HotTable} from "@handsontable/vue";
import "handsontable/languages/fr-FR";
import apiClient from "../../../config/api.js";
import moment from "moment";
import "vue-loading-overlay/dist/vue-loading.css";
import * as XLSX from 'xlsx';

function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

export default {
  name: "session",
  components: {HotTable},
  data: function () {
    return {
      isMobile: isMobileDevice(),
      disableMainBtn: false,
      searchName: "",
      lastHighlitedRow: null,
      loading: false,
      loading2: false,
      tab: null,
      dialog: false,
      alert: false,
      fullPage: false,
      text: "",
      color: "",
      type: null,
      elapse: null,
      file: "",
      editedIndex: -1,
      errors: [],
      excelData: [],
      selectedRows: [],
      dataIsEmpty: true,
      toObject: [],
      hotSettings: {
        renderAllRows: false,          // Rendu virtuel
        viewportRowRenderingOffset: 'auto',  // Calcul dynamique
        data: [],
        colWidths: 100,
        width: "100%",
        height: "675px",
        fixedRowsTop: 0,
        columnSorting: true,
        sortIndicator: true,
        filters: true,
        selectionMode: "multiple",
        dropdownMenu: ["filter_by_condition", "filter_action_bar", "filter_operators", "filter_by_value"],
        licenseKey: "non-commercial-and-evaluation",
        stretchH: "all",
        minSpareRows: false,
        language: "fr-FR",
        customBorders: true,
        columnHeaders: true,
        rowHeaders: true,
        stretch: "all",
        readOnly: true,
        afterFilter: this.afterFilter,
        afterLoadData: this.afterLoadData,
        currentRowClassName: 'rowHighlight',
        manualColumnResize: true,
        className: "htCenter htMiddle",
        afterSelectionEnd: this.afterSelectionEnd,
        afterDeselect: this.afterDeselect,
        hiddenColumns: {
          columns: [0],
          indicators: false
        },
        colHeaders: [
          "Id", "Identifiant TPE", "Nom site", "Nom entreprise", "Nom caissier", "Matricule", "Type", "Date session"
        ],
        columns: [
          {title: "Id", width: "10px"},
          {title: "Identifiant TPE", width: "100px"},
          {title: "Nom site", width: "100px"},
          {title: "Nom entreprise", width: "100px"},
          {title: "Nom caissier", width: "100px"},
          {title: "Matricule", width: "80px"},
          {title: "Type", width: "100px"},
          {title: "Date session", width: "100px", align: "center", type: "date"},
        ]
      }
    }
  },
  created() {
    this.getData()
  },

  methods: {
    isEmpty(str) {
      return (!str || 0 === str.length || /^\s*$/.test(str));
    },
    cleared() {
      this.searchName = "";
      this.getData();
    },
    search() {
      var query = this.isEmpty(this.searchName) ? this.searchName : this.searchName.toLowerCase()

      if (this.isEmpty(query)) {
        this.cleared()
      }

      var row;
      var col;
      var rLen;
      var cLen;
      var data = this.$refs.hotTable.hotInstance.getData();
      var array = [];
      for (row = 0, rLen = data.length; row < rLen; row++) {
        for (col = 0, cLen = Object.keys(data[row]).length; col < cLen; col++) {
          var x = Object.keys(data[row])[col];
          if (('' + data[row][x]).toLowerCase().indexOf(query) > -1) {
            array.push(data[row]);
            break;
          }
        }
      }
      this.$refs.hotTable.hotInstance.loadData(array);

      // Mettre à jour dataIsEmpty après le filtrage
      this.dataIsEmpty = array.length === 0;

      // Réinitialiser la sélection lors d'une recherche
      this.selectedRows = [];
    },
    afterDeselect() {
      // Cette méthode est appelée après que l'utilisateur ait déselectionné une ou plusieurs lignes
      // Utilisons setTimeout pour permettre à Handsontable de terminer ses opérations internes
      setTimeout(() => {
        const selected = this.$refs.hotTable.hotInstance.getSelected();

        // Si rien n'est sélectionné ou si la sélection est vide, réinitialiser selectedRows
        if (!selected || selected.length === 0) {
          this.selectedRows = [];
        } else {
          // Mettre à jour la liste des lignes sélectionnées
          this.updateSelectedRows();
        }
      }, 50);
    },
    updateSelectedRows() {
      // Récupérer toutes les sélections actives
      const selected = this.$refs.hotTable.hotInstance.getSelected();
      this.selectedRows = [];

      if (selected && selected.length > 0) {
        // Pour chaque sélection
        selected.forEach(selection => {
          const startRow = Math.min(selection[0], selection[2]);
          const endRow = Math.max(selection[0], selection[2]);

          // Ajouter chaque ligne de la sélection
          for (let row = startRow; row <= endRow; row++) {
            const rowData = this.$refs.hotTable.hotInstance.getDataAtRow(row);
            if (rowData && rowData[0]) {
              // Vérifier si cette ligne n'est pas déjà dans selectedRows
              if (!this.selectedRows.some(item => item.index === row)) {
                this.selectedRows.push({
                  index: row,
                  id: rowData[0]
                });
              }
            }
          }
        });
      }
    },
    afterSelectionEnd(r, c, r2, c2) {
      // Mettre à jour les lignes sélectionnées après une sélection
      this.updateSelectedRows();
    },
    removeSelectedRows() {
      if (this.selectedRows.length === 0) return;

      let message = {
        title: 'Fenêtre de confirmation',
        body: `Confirmez la suppression de ${this.selectedRows.length} session(s).`
      };

      this.$dialog
          .confirm(message)
          .then(dialog => {
            this.loading = true;

            // Trier les index en ordre décroissant pour éviter les problèmes de suppression
            const sortedRows = [...this.selectedRows].sort((a, b) => b.index - a.index);
            const ids = this.selectedRows.map(row => row.id);

            // Créer un body pour l'API avec la liste des IDs
            const requestBody = {
              sessionIds: ids
            };

            apiClient
                .post(
                    `${this.$store.getters.user.baseUrl}/wallet/delete_wallet_sessions/${sessionStorage.getItem("accountId")}`,
                    requestBody
                )
                .then(res => {
                  dialog.close();
                  this.loading = false;
                  if (res.data.status === 200) {
                    // Suppression réussie, mettre à jour les données
                    // Supprimer les lignes du tableau (commencer par les plus hauts index)
                    sortedRows.forEach(row => {
                      this.$refs.hotTable.hotInstance.alter('remove_row', row.index);
                    });

                    this.selectedRows = [];

                    // Vérifier si le tableau est vide après suppression
                    const remainingData = this.$refs.hotTable.hotInstance.getData();
                    this.dataIsEmpty = remainingData.length === 0;

                    this.color = "#009688";
                    this.text = res.data.message || "Sessions supprimées avec succès";
                    this.showAlert('info');
                  } else {
                    this.color = "#F44336";
                    this.text = res.data.message || "Erreur lors de la suppression";
                    this.showAlert('warning');
                  }

                  this.refresh()
                })
                .catch((error) => {
                  dialog.close();
                  this.loading = false;
                  this.color = "#F44336";
                  this.text = error.message || "Erreur lors de la suppression";
                  this.showAlert('warning');
                });
          })
          .catch(() => {
            // Annulation de la suppression
            this.loading = false;
          });
    },
    getData() {
      this.loading = true
      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/wallet/get_wallet_sessions/` + sessionStorage.getItem("accountId")
          )
          .then(response => {
            this.loading = false
            let tabArray = []
            let newObj = response.data.datas;

            if (response.data.status !== 200) {
              this.color = "#009688"
              this.text = response.data.message;
              this.showAlert('warning')
              this.disableMainBtn = true
            } else {
              this.disableMainBtn = false
            }

            String.prototype.capitalize = function (allWords) {
              return (allWords) ? // if all words
                  this.split(' ').map(word => word.capitalize()).join(' ') : //break down phrase to words then  recursive calls until capitalizing all words
                  this.charAt(0).toUpperCase() + this.slice(1); // if allWords is undefined , capitalize only the first word , mean the first char of the whole string
            }

            newObj.forEach((item) => {
              tabArray.push([
                item["id"],
                item["dtoWalletTpe"].identifiant,
                item["dtoWalletTpe"].nomSite.toUpperCase(),
                item["dtoWalletTpe"].nomEntreprise.toUpperCase(),
                item["caissier"].accountLastname.toUpperCase() + " " + item["caissier"].accountFirstname.toLowerCase().capitalize(true),
                item["caissier"].userId,
                item["type"],
                this.datefull(item["dateSession"])
              ])
            })

            this.$refs.hotTable.hotInstance.loadData(tabArray)

            // Mettre à jour dataIsEmpty quand les données sont chargées
            this.dataIsEmpty = tabArray.length === 0;

            this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]
          })
          .catch(() => {
            this.loading = false
            this.dataIsEmpty = true; // En cas d'erreur, considérer les données comme vides
          });
    },
    dynamicID() {
      return 'dynamicID-' + Math.floor(Math.random() * Date.now().toString());
    },
    onCancel() {
      this.loading = false
    },
    refresh() {
      this.getData()
      this.selectedRows = [];
    },
    datefull(val) {
      if (!val) {
        return
      }
      const date = new Date(val);
      return moment(date).format("DD-MM-YYYY HH:mm:ss");
    },
    AlertColor(type) {
      return type === "info" ? "#4CAF50" : "#F44336";
    },
    showAlert(type) {
      this.type = type

      let timer = this.showAlert.timer
      if (timer) {
        clearTimeout(timer)
      }
      this.showAlert.timer = setTimeout(() => {
        this.type = null
      }, 20000)

      this.elapse = 1
      let t = this.showAlert.t
      if (t) {
        clearInterval(t)
      }

      this.showAlert.t = setInterval(() => {
        if (this.elapse === 3) {
          this.elapse = 0
          clearInterval(this.showAlert.t)
        } else {
          this.elapse++
        }
      }, 5000)
    },
    dismissible_close() {
      this.elapse = 3
      clearTimeout(this.showAlert.timer)
      clearInterval(this.showAlert.t)
      this.type = null
    },
    onexport() { // On Click Excel download button
      this.loading = true
      // export json to Worksheet of Excel
      // only array possible
      var datas = XLSX.utils.json_to_sheet(this.toObject, {skipHeader: true})
      // var pokemonWS = XLSX.utils.json_to_sheet(this.Datas.pokemons)

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new() // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, datas, "Sessions") // sheetAName is name of Worksheet
      // XLSX.utils.book_append_sheet(wb, pokemonWS, "pokemons")

      // export Excel file
      XLSX.writeFile(wb, "Sessions.xlsx") // name of the file is "book.xlsx"
      this.loading = false
    },

    afterLoadData() {
      const data = this.$refs.hotTable.hotInstance.getData();
      this.dataIsEmpty = !data || data.length === 0;
      this.selectedRows = [];
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]
    },

    afterFilter() {
      const data = this.$refs.hotTable.hotInstance.getData();
      this.dataIsEmpty = !data || data.length === 0;
      this.selectedRows = [];
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]
    },
  },
};
</script>

<style scoped>
.toolbar .v-toolbar__content {
  padding: 0 !important
}

.v-text-field {
  min-width: 222px;
}

.custom-btn {
  width: 222px;
}

.custom-btn::before {
  color: transparent
}

.custom-btn:hover {
  color: #F5F5F5 !important;
}

.centered-input >>> input {
  text-align: center !important;
}
</style>